import { z } from 'zod';

const cardLanguageMessages = z.object({
  title: z.string(),
  description: z.string(),
});

export const cardDataSchema = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
  i18n: z.object({
    en: cardLanguageMessages,
    es: cardLanguageMessages,
  }),
  image: z.string().optional(),
});
export type CardDataInput = z.infer<typeof cardDataSchema>;
